import { useId, type ReactElement, type ReactNode } from "react";

export interface FieldProps {
  children: (ids: { controlId: string; describedBy?: string }) => ReactElement;
  error?: string;
  hint?: string;
  label: ReactNode;
  required?: boolean;
}

export function Field({ children, error, hint, label, required = false }: FieldProps) {
  const controlId = useId();
  const hintId = useId();
  const errorId = useId();
  const describedBy = [hint ? hintId : null, error ? errorId : null]
    .filter(Boolean)
    .join(" ");

  return (
    <div>
      <label className="mb-1.5 block text-sm font-medium text-ink" htmlFor={controlId}>
        {label}
        {required && <span aria-hidden="true"> *</span>}
      </label>
      {children({ controlId, describedBy: describedBy || undefined })}
      {hint && (
        <p className="mt-1.5 text-sm text-muted" id={hintId}>
          {hint}
        </p>
      )}
      {error && (
        <p className="mt-1.5 text-sm text-danger" id={errorId}>
          {error}
        </p>
      )}
    </div>
  );
}
